var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.tags),function(tag){return _c('li',{key:tag.type},[_c('filter-tag',_vm._g(_vm._b({},'filter-tag',tag,false),_vm.$listeners))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }